import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { SalesforceSettingDirectory } from "../../../../constants/ComponentTypes";

const styles = () => ({
  root: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    padding: "60px 0",
  },

  box: {
    maxWidth: "940px",
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginBottom: "90px",
  },

  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "26px",
  },

  desc: {
    fontSize: "14px",
    paddingBottom: "20px",
  },

  row: {
    marginBottom: "30px",
  },

  fieldTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "12px",
  },

  note: {
    color: "#5A5B62",
    fontSize: "12px",
    marginTop: "20px",
  },
});

/**
 * Salesforceのマッピングステップ画面のラッパーコンポーネント
 */
class SalesforceMapping extends React.Component {
  isImport = () => {
    const { salesforceSettingDirectory } = this.props;
    return salesforceSettingDirectory.value === SalesforceSettingDirectory.ADDRESS_BOOK.value;
  }

  render() {
    const { classes, step, salesforceSettingStep, salesforceSettingDirectory } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <Typography variant="subheading" className={classes.title}>
            {step === salesforceSettingStep.MAPPING ? "同期する項目をマッピングしてください" : "以下のマッピングで同期します。よろしいですか？"}
          </Typography>
          <Typography variant="body2" className={classes.desc}>
            {step === salesforceSettingStep.MAPPING ? salesforceSettingDirectory.mapping_setup_desc : salesforceSettingDirectory.preview_setup_desc}
          </Typography>

          {step === salesforceSettingStep.PREVIEW && (
            <div className={classes.fields}>
              <div className={classes.row}>
                <Typography variant="title" className={classes.fieldTitle}>
                  Salesforceオブジェクト
                </Typography>
                <Typography variant="body2" className={classes.fieldDesc}>
                  {this.props.sobjectName}
                </Typography>
              </div>
            </div>
          )}

          <div className={classes.row}>
            <Typography variant="title" className={classes.fieldTitle}>
              {this.isImport() ? "インポート" : "エクスポート"}設定・項目マッピング
            </Typography>
            {this.props.children}

            {step === salesforceSettingStep.MAPPING && (
              <Typography className={classes.note}>
                {salesforceSettingDirectory.mapping_cation_desc}
              </Typography>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SalesforceMapping.propTypes = {
  classes: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  salesforceSettingStep: PropTypes.object.isRequired,
  salesforceSettingDirectory: PropTypes.object.isRequired,
  sobjectName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(SalesforceMapping);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceMapping.jsx